import { addSPAccountEventUserToGlobalContext } from '../utils/SnowplowUtils';

export const startSnowplowTrackingAction = () =>
    (_, getState) => {
        const {
            meReducer: { me },
            eventReducer: { event }
        } = getState();
        addSPAccountEventUserToGlobalContext(me, event);
    };
